<template>
  <div class="page">
        <div class="mainListT cf">
            <h3  class="float-l">合并运动会列表</h3>
           
        </div>
        <div class="TableListMain">
            
            <div class="TableList">
                <Table  stripe border :columns="registerColumns" :data="registerData" ></Table>
            </div>
        </div>
       
  </div>
</template>

<script>
import {sportermeetingmerge,gamerollback} from '@/lib/api/index.js'



let requiredStr = '必选项不能为空！'
export default {
   computed: {
    
   },
   components: {
     
  },
  data(){
    return {
        // 新增运动会
        pag:{//分页
            page_no: 1,
            page_size:  10,
            beginTime:'',
            endTime:'',
            gameNameCHN:'',
            sourceType:1
        },
        formItem:{//分页
            page_no: 1,
            beginTime:'',
            endTime:'',
            page_size:  10,
            gameNameCHN:'',
            sourceType:1
        },
        loading:true,
        registerColumns: [
             {
                type: 'selection',
                align:'center', 
                width:50,

            },
            {
                type:'index',
                title: '序号',
                align:'center',

            },
            {
                title: '合并前运动会名称',
                key: 'sourceGameNameCHN',
                
            },
            {
                title: '合并前运动会开始时间',
                key: 'gameTime',
                render: (h, params) =>{
                    return h('div', 
                        this.$PlugIn.formatDateTime(params.row.gameTime)
                    );
                }
            },
            {
                title: '合并后运动会名称',
                key: 'targetGameNameCHN',
            },
            {
                title: '操作',
                align: 'center',
                render: (h, params) => {
                        return h('div',{
                            style: {
                                paddingTop: '6px',
                                paddingBottom: '6px',
                                
                            }
                        },[
                           
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small',
                                },
                                style: {
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: '你确认要恢复合并运动会吗？',
                                            onOk: () => {
                                                const obj = {
                                                    sporterMeetingMergeID:params.row.sporterMeetingMergeID,//	是	long	运动会合并ID
                                                    sourceGameID:params.row.sourceGameID,//	是	String	源赛事ID
                                                    sourceGameNameCHN:params.row.sourceGameNameCHN,//	是	String	源赛事中文名称
                                                    gameTime:params.row.gameTime,//	是	Date	源运动会开始时间
                                                    sqlUrl:params.row.sqlUrl,//	是	String	源赛事备份数据脚本存放url
                                                    targetGameID:params.row.targetGameID,//	否	String	目标赛事ID
                                                    targetGameNameCHN:params.row.targetGameNameCHN,//	
                                                }
                                                
                                                this.upGamerollback(obj);
                                            }
                                        });
                                    }
                                }
                            }, '恢复合并运动会'),
                           
                        ]);

                }
            }
        ],         
        registerData: [],
       
    
    }
  },
  methods:{
    getSportermeetingmerge()//获取运动会列表
    {
        
        sportermeetingmerge().then(res => {
            if(res.data.code == 0){
           
                this.registerData = res.data.data;
            }else if(res.data.code == -2){
                this.$Message.error("获取失败");
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
            }

            this.loading = false;
        },err =>{
            this.$Message.error("网络连接失败");
        });
    },
    upGamerollback(obj)
    {
        gamerollback(obj).then(res => {
            if(res.data.code == 0){
                this.getSportermeetingmerge();
                this.$Message.info("成功恢复");
            }else if(res.data.code == -2){
                this.$Message.error("恢复失败");
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
            }

        },err =>{
            this.$Message.error("网络连接失败");
        });
    }
  },
  mounted() {
      this.getSportermeetingmerge();
  },
}
</script>
<style scoped  lang="less">
.sporterEventList{padding-bottom: 32px;}
.sporterEventList .ivu-checkbox-default label{width:120px;padding-top: 6px;}
.page{
    
    .fromDiv{
      max-width: 1200px;
    }
    .ivu-date-picker{
      display: block;
    }
    .UpBut{
      padding-top: 22px;
      max-width: 1200px;
      button{min-width: 100px;}
    }
   
}

 .GroupUpBut{
        padding-top: 22px;
    }
.GroupListTable{max-height: 300px;overflow-y: auto}
/*定义滚动条的轨道，内阴影及圆角*/
.GroupListTable::-webkit-scrollbar-track{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 2px;
  background-color: #f5f5f5;
  
}
/*定义滑块，内阴影及圆角*/
.GroupListTable::-webkit-scrollbar-thumb{
  border-radius:2px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color:#ddd;
 
}

.GroupListTable::-webkit-scrollbar{
  width: 4px;
  background-color: #f5f5f5;
}
.exceluPloadBtn{height:32px;line-height: 32px;overflow: hidden;border-radius: 4px;cursor:pointer;}
.exceluPloadBtn input{opacity: 0;font-size: 0px;width:100%;height: 100%;display: block;left: 0;top: 0;cursor:pointer;}
.TableListMain{min-height: 500px;}
.note{padding:12px;color: red;}
.sportermeetingPage{margin-top:-100px;margin-bottom: 68px;z-index: 99;position: relative;}
#historical{display: none;}
</style>




// WEBPACK FOOTER //
// src/view/sportermeetingMerge.vue